/**
 * 专利信息
 */

import request from '@/utils/request'

/**
 * 根据条件分页查询专利
 * @param data
 */
export function patentSelectPage(data) {
  return request({
    url: '/patent/select/page',
    method: 'post',
    data
  })
}

/**
 * 新增专利
 * @param data
 */
export function patentAdd(data) {
  return request({
    url: '/patent/add',
    method: 'post',
    data
  })
}

/**
 * 修改专利
 * @param data
 */
export function patentUpdate(data) {
  return request({
    url: '/patent/update',
    method: 'post',
    data
  })
}

/**
 * 批量删除专利
 * @param ids
 */
export function patentBatchDelete(ids) {
  return request({
    url: '/patent/batch/delete',
    method: 'post',
    data: { ids: ids }
  })
}

/**
 * 批量启用、禁用专利
 * @param ids
 * @param isAvaliable
 */
export function patentBatchAvaliable(ids, isAvaliable) {
  return request({
    url: '/patent/batch/avaliable',
    method: 'post',
    data: { ids: ids, isAvaliable: isAvaliable }
  })
}

/**
 * 根据主键ID查询专利
 * @param id
 */
export function patentSelectById(id) {
  return request({
    url: '/patent/select/byId',
    method: 'post',
    data: { id: id }
  })
}

/**
 * 导入专利
 * @param file
 */
export function patentImport(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/patent/import',
    method: 'post',
    data: formData
  })
}

/**
* 根据专利申请号同步专利信息
* @param patentAppNo
* @param country
*/
export function patentSyncAppNo(patentAppNo, country) {
  return request({
    url: '/patent/sync/appNo',
    method: 'post',
    data: { patentAppNo: patentAppNo, country: country }
  })
}

/**
* 根据专利公布号同步专利信息
* @param publicationNumber
* @param country
*/
export function patentSyncPubNo(publicationNumber, country) {
  return request({
    url: '/patent/sync/pubNo',
    method: 'post',
    data: { publicationNumber: publicationNumber, country: country }
  })
}


/**
 * 查询专利授权用户列表
 * @param data
 */
export function projectUserAssign(data) {
  return request({
    url: '/patent/permission/user',
    method: 'post',
    data
  })
}

/**
 * 权限管理的公司授权列表
 * @param data
 */
export function userGetPermissionCompany(data) {
  return request({
    url: '/patent/permission/company',
    method: 'post',
    data
  })
}
/**
 * 权限管理的项目授权列表
 * @param data
 */
export function userGetPermissionProject(data) {
  return request({
    url: '/patent/permission/project',
    method: 'post',
    data
  })
}




